import React, {useEffect, useState} from 'react';
import '../CSS/style/style.css';
import logo from "../resource/water_about.jpeg";
import RoomCarousel from "./RoomCarousel";

const Rooms = () => {
    const [activeTab, setActiveTab] = useState(1);
    const [isMobile, setIsMobile] = useState(false);

    const A = [
        {seq:1,title:'A',img:'A_01.jpeg'},
        {seq:2,title:'A',img:'A_02.jpeg'},
        {seq:3,title:'A',img:'A_03.jpeg'},
        {seq:4,title:'A',img:'A_04.jpeg'},
        {seq:5,title:'A',img:'A_05.jpeg'},
        {seq:6,title:'A',img:'A_06.jpeg'},
        {seq:7,title:'A',img:'A_07.jpeg'},
    ]

    const B = [
        {seq:0,type:'video',src:'neuleub.mp4'},
        {seq:1,title:'B',img:'B_01.jpeg'},
        {seq:2,title:'B',img:'B_02.jpeg'},
        {seq:3,title:'B',img:'B_03.jpeg'},
        {seq:4,title:'B',img:'B_04.jpeg'},
        {seq:5,title:'B',img:'B_05.jpeg'},
        {seq:6,title:'B',img:'B_06.jpeg'},
    ]

    const C = [
        {seq:0,type:'video',src:'sonamu.mp4'},
        {seq:1,title:'C',img:'C_01.jpeg'},
        {seq:2,title:'C',img:'C_02.jpeg'},
        {seq:3,title:'C',img:'C_03.jpeg'},
        {seq:4,title:'C',img:'C_04.jpeg'},
    ]

    const D = [
        {seq:0,type:'video',src:'Chinese.mp4'},
        {seq:1,title:'D',img:'D_01.jpeg'},
        {seq:2,title:'D',img:'D_02.jpeg'},
        {seq:3,title:'D',img:'D_03.jpeg'},
        {seq:4,title:'D',img:'D_04.jpeg'},
    ]

    const  E = [
        {seq:0,type:'video',src:'bolisu.mp4'},
        {seq:1,title:'E',img:'E_01.jpeg'},
        {seq:2,title:'E',img:'E_02.jpeg'},
        {seq:3,title:'E',img:'E_03.jpeg'},
    ]

    const F = [
        {seq:0,type:'video',src:'danpung.mp4'},
        {seq:1,title:'F',img:'F_01.jpeg'},
        {seq:2,title:'F',img:'F_02.jpeg'},
        {seq:3,title:'F',img:'F_03.jpeg'},
    ]

    useEffect(() => {
        // 최초 렌더 시 체크
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        // 리사이즈에도 반응하고 싶으면 아래 3줄 유지
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    return (
        <div className="main-wrapper">
            <section className="foot-banner"></section>

            <div className="main-container">
                <div className="tab-buttons">
                    <button
                        onClick={() => setActiveTab(1)}
                        className={activeTab === 1 ? 'tab-button active' : 'tab-button'}>
                        {isMobile ? '자귀방' : '자귀나무방'}
                    </button>
                    <button
                        onClick={() => setActiveTab(2)}
                        className={activeTab === 2 ? 'tab-button active' : 'tab-button'}
                    >
                        {isMobile ? '느릅방' : '느릅나무방'}
                    </button>
                    <button
                        onClick={() => setActiveTab(3)}
                        className={activeTab === 3 ? 'tab-button active' : 'tab-button'}
                    >
                        소나무방
                    </button>
                    <button
                        onClick={() => setActiveTab(4)}
                        className={activeTab === 4 ? 'tab-button active' : 'tab-button'}
                    >
                        {isMobile ? '이팝방' : '이팝나무방'}
                    </button>
                    <button
                        onClick={() => setActiveTab(5)}
                        className={activeTab === 5 ? 'tab-button active' : 'tab-button'}
                    >
                        보리수방
                    </button>
                    <button
                        onClick={() => setActiveTab(6)}
                        className={activeTab === 6 ? 'tab-button active' : 'tab-button'}
                    >
                        단풍방
                    </button>
                </div>

                {activeTab === 1 && (
                    <>
                        <h2>자귀나무방</h2>
                        <div>
                            <RoomCarousel images={A} idPrefix="A"/>
                        </div>
                        <div>
                            <span>
                                • 유형/형태 (거실+방1+방2+방3+다락방+화장실2개+싱글침대6개+퀸침대1개) / 단체형, 가족형 <br/>
                                • 특이사항 : 독채펜션, 펜션 내 계곡, 개별 바베큐장<br/>
                                • 구비시설 : TV,침대,에어컨,냉장고,전자레인지,커피포트,주방기구일체,욕실용품,헤어드라이기,WIFI
                            </span>
                        </div>
                        <table className="refund-table">
                            <thead>
                            <tr>
                                <td rowSpan={2}>객실<br/>(기준/최대)</td>
                                <td rowSpan={2}>특징</td>
                                <td colSpan={2}>비수기</td>
                                <td colSpan={2}>준성수기<br/><span>(6월/9월)</span></td>
                                <td colSpan={2}>성수기<br/><span>(7월/8월)</span></td>
                                <td rowSpan={2}>극성수기<br/><span>(7월 25일 ~ 8월 16일)</span></td>
                            </tr>
                            <tr style={{backgroundColor: '#eee'}}>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="객실">자귀<br/>(8인 기준)</td>
                                <td data-label="특징">온돌방+침대</td>
                                <td data-label="비수기 일~금">300,000원</td>
                                <td data-label="비수기 토요일/공휴일 전">420,000원</td>
                                <td data-label="준성수기(6월/9월) 일~금">300,000원</td>
                                <td data-label="준성수기(6월/9월) 토요일/공휴일 전">420,000원</td>
                                <td data-label="성수기(7월/8월) 일~금">420,000원</td>
                                <td data-label="성수기(7월/8월) 토요일/공휴일 전">550,000원</td>
                                <td data-label="극성수기(7월 25일 ~ 8월 16일)">550,000원</td>
                            </tr>
                            </tbody>
                        </table>
                        <br/>
                        <div>
                            <span>
                                •  주중 : 일요일~금요일 , 주말 : 토요일,공휴일 전날<br/>
                                •  입실시간 : 입실 오후15시부터, 퇴실 오전11시까지<br/>
                                •  기준인원 : 기준8명/최대12명<br/>
                                •  인원추가금액 : 1인당 성인 20,000원 / 아동(초등학생부터) 20,000원 / 미취학아동 없음
                            </span>
                        </div>
                    </>
                )}

                {activeTab === 2 && (
                    <>
                        <h2>느릅나무방</h2>
                        <div>
                            <RoomCarousel images={B} idPrefix="B"/>
                        </div>
                        <div>
                            <span>
                                • 유형/형태 (거실+방+다락방+화장실+싱글침대2개+퀸침대1개) / 단체형, 가족형 <br/>
                                • 특이사항 : 독채펜션, 펜션 내 계곡, 개별 바베큐장<br/>
                                • 구비시설 : TV,침대,에어컨,냉장고,전자레인지,커피포트,식탁,주방기구일체,욕실용품,헤어드라이기,WIFI
                            </span>
                        </div>
                        <table className="refund-table">
                            <thead>
                            <tr>
                                <td rowSpan={2}>객실<br/>(기준/최대)</td>
                                <td rowSpan={2}>특징</td>
                                <td colSpan={2}>비수기</td>
                                <td colSpan={2}>준성수기<br/><span>(6월/9월)</span></td>
                                <td colSpan={2}>성수기<br/><span>(7월/8월)</span></td>
                                <td rowSpan={2}>극성수기<br/><span>(7월 25일 ~ 8월 16일)</span></td>
                            </tr>
                            <tr style={{backgroundColor: '#eee'}}>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="객실">느릅<br/>(6인 기준)</td>
                                <td data-label="특징">온돌방+침대</td>
                                <td data-label="비수기 일~금">170,000원</td>
                                <td data-label="비수기 토요일/공휴일 전">220,000원</td>
                                <td data-label="준성수기(6월/9월) 일~금">170,000원</td>
                                <td data-label="준성수기(6월/9월) 토요일/공휴일 전">300,000원</td>
                                <td data-label="성수기(7월/8월) 일~금">300,000원</td>
                                <td data-label="성수기(7월/8월) 토요일/공휴일 전">380,000원</td>
                                <td data-label="극성수기(7월 25일 ~ 8월 16일)">380,000원</td>
                            </tr>
                            </tbody>
                        </table>
                        <br/>
                        <div>
                            <span>
                                •  주중 : 일요일~금요일 , 주말 : 토요일,공휴일 전날<br/>
                                •  입실시간 : 입실 오후15시부터, 퇴실 오전11시까지<br/>
                                •  기준인원 : 기준6명/최대8명<br/>
                                •  인원추가금액 : 1인당 성인 20,000원 / 아동(초등학생부터) 20,000원 / 미취학아동 없음
                            </span>
                        </div>
                    </>
                )}

                {activeTab === 3 && (
                    <>
                        <h2>소나무방</h2>
                        <div>
                            <RoomCarousel images={C} idPrefix="C"/>
                        </div>
                        <div>
                            <span>
                                • 유형/형태 (거실+다락방+화장실+싱글침대4개or퀸침대2개) / 커플형, 가족형 <br/>
                                • 특이사항 : 독채펜션, 펜션 내 계곡, 개별 바베큐장<br/>
                                • 구비시설 : TV,침대,에어컨,냉장고,전자레인지,커피포트,식탁,주방기구일체,욕실용품,헤어드라이기,WIFI
                            </span>
                        </div>
                        <table className="refund-table">
                            <thead>
                            <tr>
                                <td rowSpan={2}>객실<br/>(기준/최대)</td>
                                <td rowSpan={2}>특징</td>
                                <td colSpan={2}>비수기</td>
                                <td colSpan={2}>준성수기<br/><span>(6월/9월)</span></td>
                                <td colSpan={2}>성수기<br/><span>(7월/8월)</span></td>
                                <td rowSpan={2}>극성수기<br/><span>(7월 25일 ~ 8월 16일)</span></td>
                            </tr>
                            <tr style={{backgroundColor: '#eee'}}>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="객실">소나무<br/>(4인 기준)</td>
                                <td data-label="특징">온돌방+침대</td>
                                <td data-label="비수기 일~금">120,000원</td>
                                <td data-label="비수기 토요일/공휴일 전">170,000원</td>
                                <td data-label="준성수기(6월/9월) 일~금">120,000원</td>
                                <td data-label="준성수기(6월/9월) 토요일/공휴일 전">220,000원</td>
                                <td data-label="성수기(7월/8월) 일~금">220,000원</td>
                                <td data-label="성수기(7월/8월) 토요일/공휴일 전">300,000원</td>
                                <td data-label="극성수기(7월 25일 ~ 8월 16일)">300,000원</td>
                            </tr>
                            </tbody>
                        </table>
                        <br/>
                        <div>
                            <span>
                               •  주중 : 일요일~금요일 , 주말 : 토요일,공휴일 전날<br/>
                                •  입실시간 : 입실 오후15시부터, 퇴실 오전11시까지<br/>
                                •  기준인원 : 기준4명/최대6명<br/>
                                •  인원추가금액 : 1인당 성인 20,000원 / 아동(초등학생부터) 20,000원 / 미취학아동 없음
                            </span>
                        </div>
                    </>
                )}

                {activeTab === 4 && (
                    <>
                        <h2>이팝나무방</h2>
                        <div>
                            <RoomCarousel images={D} idPrefix="D"/>
                        </div>
                        <div>
                            <span>
                                • 유형/형태 (거실+다락방+화장실+싱글침대4개or퀸침대2개) / 커플형, 가족형 <br/>
                                • 특이사항 : 독채펜션, 펜션 내 계곡, 개별 바베큐장<br/>
                                • 구비시설 : TV,침대,에어컨,냉장고,전자레인지,커피포트,식탁,주방기구일체,욕실용품,헤어드라이기,WIFI
                            </span>
                        </div>
                        <table className="refund-table">
                            <thead>
                            <tr>
                                <td rowSpan={2}>객실<br/>(기준/최대)</td>
                                <td rowSpan={2}>특징</td>
                                <td colSpan={2}>비수기</td>
                                <td colSpan={2}>준성수기<br/><span>(6월/9월)</span></td>
                                <td colSpan={2}>성수기<br/><span>(7월/8월)</span></td>
                                <td rowSpan={2}>극성수기<br/><span>(7월 25일 ~ 8월 16일)</span></td>
                            </tr>
                            <tr style={{backgroundColor: '#eee'}}>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="객실">이팝<br/>(4인 기준)</td>
                                <td data-label="특징">온돌방+침대</td>
                                <td data-label="비수기 일~금">120,000원</td>
                                <td data-label="비수기 토요일/공휴일 전">170,000원</td>
                                <td data-label="준성수기(6월/9월) 일~금">120,000원</td>
                                <td data-label="준성수기(6월/9월) 토요일/공휴일 전">220,000원</td>
                                <td data-label="성수기(7월/8월) 일~금">220,000원</td>
                                <td data-label="성수기(7월/8월) 토요일/공휴일 전">300,000원</td>
                                <td data-label="극성수기(7월 25일 ~ 8월 16일)">300,000원</td>
                            </tr>
                            </tbody>
                        </table>
                        <br/>
                        <div>
                            <span>
                                •  주중 : 일요일~금요일 , 주말 : 토요일,공휴일 전날<br/>
                                •  입실시간 : 입실 오후15시부터, 퇴실 오전11시까지<br/>
                                •  기준인원 : 기준4명/최대6명<br/>
                                •  인원추가금액 : 1인당 성인 20,000원 / 아동(초등학생부터) 20,000원 / 미취학아동 없음
                            </span>
                        </div>
                    </>
                )}


                {activeTab === 5 && (
                    <>
                        <h2>보리수방</h2>
                        <div>
                            <RoomCarousel images={E} idPrefix="E"/>
                        </div>
                        <div>
                            <span>
                                • 유형/형태 (거실+다락방+화장실+싱글침대4개or퀸침대2개) / 커플형, 가족형 <br/>
                                • 특이사항 : 독채펜션, 펜션 내 계곡, 개별 바베큐장<br/>
                                • 구비시설 : TV,침대,에어컨,냉장고,전자레인지,커피포트,식탁,주방기구일체,욕실용품,헤어드라이기,WIFI
                            </span>
                        </div>
                        <table className="refund-table">
                            <thead>
                            <tr>
                                <td rowSpan={2}>객실<br/>(기준/최대)</td>
                                <td rowSpan={2}>특징</td>
                                <td colSpan={2}>비수기</td>
                                <td colSpan={2}>준성수기<br/><span>(6월/9월)</span></td>
                                <td colSpan={2}>성수기<br/><span>(7월/8월)</span></td>
                                <td rowSpan={2}>극성수기<br/><span>(7월 25일 ~ 8월 16일)</span></td>
                            </tr>
                            <tr style={{backgroundColor: '#eee'}}>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="객실">보리수<br/>(2인 기준)</td>
                                <td data-label="특징">온돌방+침대</td>
                                <td data-label="비수기 일~금">90,000원</td>
                                <td data-label="비수기 토요일/공휴일 전">120,000원</td>
                                <td data-label="준성수기(6월/9월) 일~금">90,000원</td>
                                <td data-label="준성수기(6월/9월) 토요일/공휴일 전">180,000원</td>
                                <td data-label="성수기(7월/8월) 일~금">180,000원</td>
                                <td data-label="성수기(7월/8월) 토요일/공휴일 전">250,000원</td>
                                <td data-label="극성수기(7월 25일 ~ 8월 16일)">250,000원</td>
                            </tr>
                            </tbody>
                        </table>
                        <br/>
                        <div>
                            <span>
                                •  주중 : 일요일~금요일 , 주말 : 토요일,공휴일 전날<br/>
                                •  입실시간 : 입실 오후15시부터, 퇴실 오전11시까지<br/>
                                •  기준인원 : 기준2명/최대4명<br/>
                                •  인원추가금액 : 1인당 성인 20,000원 / 아동(초등학생부터) 20,000원 / 미취학아동 없음
                            </span>
                        </div>
                    </>
                )}

                {activeTab === 6 && (
                    <>
                        <h2>단풍방</h2>
                        <div>
                            <RoomCarousel images={F} idPrefix="F"/>
                        </div>
                        <div>
                            <span>
                                • 유형/형태 (거실+다락방+화장실+싱글침대4개or퀸침대2개) / 커플형, 가족형 <br/>
                                • 특이사항 : 독채펜션, 펜션 내 계곡, 개별 바베큐장<br/>
                                • 구비시설 : TV,침대,에어컨,냉장고,전자레인지,커피포트,식탁,주방기구일체,욕실용품,헤어드라이기,WIFI
                            </span>
                        </div>
                        <table className="refund-table">
                            <thead>
                            <tr>
                                <td rowSpan={2}>객실<br/>(기준/최대)</td>
                                <td rowSpan={2}>특징</td>
                                <td colSpan={2}>비수기</td>
                                <td colSpan={2}>준성수기<br/><span>(6월/9월)</span></td>
                                <td colSpan={2}>성수기<br/><span>(7월/8월)</span></td>
                                <td rowSpan={2}>극성수기<br/><span>(7월 25일 ~ 8월 16일)</span></td>
                            </tr>
                            <tr style={{backgroundColor: '#eee'}}>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                                <td>일~금</td>
                                <td>토요일/공휴일 전</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="객실">단풍<br/>(2인 기준)</td>
                                <td data-label="특징">온돌방+침대</td>
                                <td data-label="비수기 일~금">90,000원</td>
                                <td data-label="비수기 토요일/공휴일 전">120,000원</td>
                                <td data-label="준성수기(6월/9월) 일~금">90,000원</td>
                                <td data-label="준성수기(6월/9월) 토요일/공휴일 전">180,000원</td>
                                <td data-label="성수기(7월/8월) 일~금">180,000원</td>
                                <td data-label="성수기(7월/8월) 토요일/공휴일 전">250,000원</td>
                                <td data-label="극성수기(7월 25일 ~ 8월 16일)">250,000원</td>
                            </tr>
                            </tbody>
                        </table>
                        <br/>
                        <div>
                            <span>
                                •  주중 : 일요일~금요일 , 주말 : 토요일,공휴일 전날<br/>
                                •  입실시간 : 입실 오후15시부터, 퇴실 오전11시까지<br/>
                                •  기준인원 : 기준2명/최대4명<br/>
                                •  인원추가금액 : 1인당 성인 20,000원 / 아동(초등학생부터) 20,000원 / 미취학아동 없음
                            </span>
                        </div>
                    </>
                )}

                <div className="room-facilities">
                    <h3>객실구비시설</h3>

                    <div className="facility-boxes">
                        <div className="facility-box">
                        <h3>기본 시설</h3>
                            <span>
                                • TV<br/>
                                • 에어컨<br/>
                                • 선풍기<br/>
                                • 냉장고<br/>
                                • 전자레인지<br/>
                                • 헤어드라이기<br/>
                                • Wi-Fi
                              </span>
                        </div>

                        <div className="facility-box">
                            <h3>주방용품</h3>
                            <span>
                                • 커피포트<br/>
                                • 압력밥솥<br/>
                                • 밥상<br/>
                                • 집기류<br/>
                                • 식기류
                              </span>
                        </div>

                        <div className="facility-box">
                            <h3>욕실용품</h3>
                            <span>
                                • 수건<br/>
                                • 샴푸.바디워시<br/>
                                • 휴지
                              </span>
                        </div>
                    </div>
                </div>


                <div className="service-desc">
                    <div className="service-desc2">
                        <h3 style={{marginTop: 0}}>◎ 입.퇴실안내</h3>
                        <span>
                          - 입실 : 오후3시 이후<br/>
                          - 퇴실 : 오전11시 이전<br/>
                          쾌적한 환경 유지를 위해 청소시간이 필요하오니 시간 엄수 부탁드립니다.
                        </span>

                        <h3>◎ 객실 이용 안내</h3>
                        <span>
                          - 모든 객실은 금연입니다. 흡연은 외부 지정된 장소를 이용해 주세요.<br/>
                          - 사전예약없는 인원초과 및 무단입실은 제한됩니다.(예약 인원외 입실시 추가요금 발생 또는 퇴실 조치 될 수 있습니다.)<br/>
                          - 반려동물 동반 입실은 절대 불가합니다.
                        </span>

                        <h3>◎ 펜션 내 에티켓</h3>
                        <span>
                          - 밤 10시 이후에는 매너타임입니다. 다른손님을 위해 실외 활동 및 소음자제를 부탁드립니다.<br/>
                          - 객실 내에서는 고기/생선굽기, 기름 사용 요리 불가합니다.<br/>
                          - 가구 및 집기류는 세척하여 제자리에 부탁드립니다.파손 시 변상비용이 청구 될 수 있습니다.<br/><br/>
                        </span>

                        <span>
                            편안하고 즐거운 여행이 되실 수 있도록 언제나 최선을 다하겠습니다.<br/>
                            감사합니다.
                        </span>
                    </div>

                    <div className="service-desc2">
                        <h3 style={{marginTop: 0}}>◎ 바베큐장 이용안내</h3>
                        <span>
                          - 이용시간은 17시 ~ 22시까지 가능합니다.<br/>
                          - 바베큐장이용은 사전예약 부탁드립니다. 날씨에 따라 운영이 제한 될 수 있습니다.
                        </span>

                        <h3>◎ 화재 및 안전주의</h3>
                        <span>
                          - 펜션 내 불꽃놀이, 폭죽, 촛불사용은 금지입니다.<br/>
                          - 개인화로 및 장작 사용 금지입니다.(화재발생위험)<br/>
                          - 화재 예방을 위해 화기 사용 시 안전수칙 준수 부탁드립니다.
                        </span>

                        <h3>◎ 퇴실 시 협조사항</h3>
                        <span>
                          - 사용한 식기류는 세척 후 정리 부탁드립니다.<br/>
                          - 쓰레기는 분리수거하여 지정 장소에 버려주세요.<br/>
                          - 퇴실 전 객실 내 조명, 냉.난방기기 전원off 확인 부탁드립니다.
                        </span>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Rooms;
